























































    import Vue from 'Vue';

    export default Vue.extend({
        name: 'profile',
        components: {
        },
        data() {
            return {selectedMap: null}
        },
        computed: {
            name(): string { return this.$store.state.profile.name; },
            showLogout(): boolean { return this.$store.state.profile.canLogout; },
            maps(): string[] { return this.$store.state.profile.maps; },
            canViewOtherMaps(): boolean {
                const showMapSwitcher = this.$store.state.profile.showMapSwitcher;                
                return this.$store.state.profile.maps && this.$store.state.profile.maps.length > 0 && showMapSwitcher === true;
            },
            selectLabel(): string { return this.$vuetify.lang.t('webmap.account.profile.selectMapLabel'); },
            linkDisabled(): boolean { return this.selectedMap === null; },
            mapLink(): string {
                return `${this.$store.getters['baseUrl']}${this.$store.state.currentCulture}/${this.selectedMap?.allowAnonymous ? 'PublicMap': 'Map'}/${this.selectedMap?.name}`;
            },
            creditsUrl(): string { return `${this.$store.getters['baseUrl']}Credits`; },
            helpUrl(): string { return `${this.$store.getters['getUserHelpUrl']}`; },
            btnAriaLabelAccount(): string { return this.$vuetify.lang.t('webmap.ariaLabels.account'); },
            btnAriaLabelView(): string { return this.$vuetify.lang.t('webmap.ariaLabels.view'); },
            btnTooltipAccount(): string { return this.$vuetify.lang.t('webmap.tooltips.account'); },
            btnTooltipView(): string { return this.$vuetify.lang.t('webmap.tooltips.view'); },
            btnTextLogout(): string { return this.$vuetify.lang.t('webmap.buttonText.logout'); },
            useDarkText(): boolean {
                return this.$store.getters['useDarkText'];
            },
            iconColour(): string {
                return this.$store.getters['textCssClass'];
            },
            buttonClass(): string {
                return `no-text-transform ${this.iconColour}`;
            },
            accountButtonClass(): string {
                return `mr-2 ${this.iconColour}`;
            }
        },
        methods: {}        
    });
